<template>
  <editor-content :editor="editor" />
</template>

<script>
import Document from '@tiptap/extension-document';
import History from '@tiptap/extension-history';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Text from '@tiptap/extension-text';
import { EditorContent, useEditor } from '@tiptap/vue-3';
import { Extension } from '@tiptap/core';

export default {
  name: 'SimpleTextEditor',
  props: {
    value: {
      type: [Object, String],
      default: () => null,
    },
    initialContent: {
      type: [Object, String],
      default: () => null,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Empty',
    },
    disableEnter: {
      type: Boolean,
      default: false,
    },
    returnStringValue: {
      type: Boolean,
      default: false,
    },
  },
  components: { EditorContent },

  emits: ['update:value'],

  setup(props, { emit }) {
    const DisableEnter = Extension.create({
      addKeyboardShortcuts() {
        return { Enter: () => true };
      },
    });
    const editor = useEditor({
      content: props.initialContent,
      extensions: [
        Document,
        Paragraph,
        Text,
        props.disableEnter ? DisableEnter : null,
        History,
        Placeholder.configure({ placeholder: props.placeholder, showOnlyWhenEditable: false }),
      ],
      onUpdate: ({ editor }) => {
        if (props.returnStringValue) {
          emit('update:value', editor.state.doc.textContent);
          return;
        }
        emit('update:value', editor.getJSON());
      },
    });

    return { editor };
  },
  watch: {
    value(val) {
      if (val !== this.editor.state.doc.textContent) {
        this.editor.commands.setContent(val);
      }
    },
  },
  mounted() {
    if (this.autoFocus) {
      this.editor.commands.focus();
    }
  },
  beforeUnmount() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss" type="text/scss">
.ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    color: map_get($grey, 'lighten-4');
    pointer-events: none;
    height: 0;
}

.ProseMirror {
    p {
      word-break: break-word;
      white-space: pre-wrap;
    }
}
</style>
